import * as pdfMakeNs from 'pdfmake/build/pdfmake';
import * as pdfFontsNs from 'pdfmake/build/vfs_fonts';

type PdfMakeApi = typeof pdfMakeNs & {
    addVirtualFileSystem: (vfs: Record<string, string>) => void;
    createPdf: (docDefinition: unknown) => {
        getBlob: () => Promise<Blob>;
        download: (fileName: string) => void;
    };
};

const resolvePdfMake = (): PdfMakeApi => {
    const mod = pdfMakeNs as PdfMakeApi & { default?: PdfMakeApi };
    return typeof mod.createPdf === 'function' ? mod : (mod.default as PdfMakeApi);
};

const resolvePdfFonts = (): Record<string, string> => {
    const mod = pdfFontsNs as Record<string, string> & {
        default?: Record<string, string>;
        pdfMake?: { vfs?: Record<string, string> };
        vfs?: Record<string, string>;
    };
    if (mod?.pdfMake?.vfs) return mod.pdfMake.vfs;
    if (mod?.vfs) return mod.vfs;
    if (mod?.default && typeof mod.default === 'object') return mod.default;
    return mod;
};

let vfsReady = false;

const ensurePdfMakeReady = (): PdfMakeApi => {
    const pdfMake = resolvePdfMake();
    if (!vfsReady) {
        // pdfmake 0.3+: register fonts via addVirtualFileSystem
        pdfMake.addVirtualFileSystem(resolvePdfFonts());
        vfsReady = true;
    }
    return pdfMake;
};

export const createPdfBlob = async (docDefinition: unknown): Promise<Blob> => {
    const blob = await ensurePdfMakeReady().createPdf(docDefinition).getBlob();
    if (!blob) throw new Error('pdf_blob_empty');
    return blob;
};

export const downloadPdf = (docDefinition: unknown, fileName: string): void => {
    ensurePdfMakeReady().createPdf(docDefinition).download(fileName);
};
